import { ReactNode } from "react";
import Maintenance from "pages/Maintenance";
import { usePortalMode } from "hooks/usePortalMode";

/**
 * Replaces the whole portal with the maintenance (or error) page while
 * `general_settings.customer_portal_mode` is anything other than `live`.
 */
const PortalMaintenanceRoute = ({ children }: { children: ReactNode }) => {
  const { mode, isChecking, checkPortalMode } = usePortalMode();

  // Hold the first render until the mode is known; showing the portal first
  // would let a customer start typing into a page that is about to vanish.
  if (!mode) {
    return null;
  }

  if (mode !== "live") {
    return (
      <Maintenance
        mode={mode}
        isChecking={isChecking}
        onCheckAgain={checkPortalMode}
      />
    );
  }

  return <>{children}</>;
};

export default PortalMaintenanceRoute;
